import React, { useEffect, useState } from 'react';
import Api from "../Api";
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Tooltip,
    BarElement
} from "chart.js";
import { Bar, Line, Pie } from "react-chartjs-2";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../Utils";
import { historyRequest } from '../store/actions/history';
import { graphics } from '../translate';

ChartJS.register(ArcElement, CategoryScale, LinearScale, Tooltip, Legend, PointElement, LineElement, BarElement);
let date = new Date()
let timeZoneStart = 'T00:00:00Z';
let timeZoneEnd = 'T23:59:59Z';
let startTime = moment(date).format('YYYY-MM-DD');
let endTime = moment(date).format('YYYY-MM-DD');
let timeStartStart = startTime + timeZoneStart;
let timeEndEnd = endTime + timeZoneEnd;

const keys = {
    "Out Call": "rgba(255, 206, 86, 1)",
    "Incoming Call": "rgba(255, 99, 132, 1)",
    "Local Call": "rgba(54, 162, 235, 1)",
    "Redirect Call": "rgba(75, 192, 192, 1)",
    "Out Call b": "rgba(255, 206, 86, 0.2)",
    "Incoming Call b": "rgba(255, 99, 132, 0.2)",
    "Local Call b": "rgba(54, 162, 235, 0.2)",
    "Redirect Call b": "rgba(75, 192, 192, 0.2)",
}

const pieBackgroundColor = {
    'NO ANSWER': 'rgba(255, 99, 132, 0.2)',
    'ANSWERED': 'rgba(54, 162, 235, 0.2)',
    'ANSWER LATER': 'rgba(255, 206, 86, 0.2)',
    'BUSY': 'rgba(75, 192, 192, 0.2)',
    'FAILED': 'rgba(153, 102, 255, 0.2)',
};

const pieBorderColor = {
    'NO ANSWER': 'rgba(255, 99, 132, 1)',
    'ANSWERED': 'rgba(54, 162, 235, 1)',
    'ANSWER LATER': 'rgba(255, 206, 86, 1)',
    'BUSY': 'rgba(75, 192, 192, 1)',
    'FAILED': 'rgba(153, 102, 255, 1)',
};


const colors = {
    'NO ANSWER': ['rgba(255, 99, 132, 0.2)', 'rgba(255, 99, 132, 1)'],
    'ANSWERED': ['rgba(54, 162, 235, 0.2)', 'rgba(54, 162, 235, 1)'],
    'ANSWER LATER': ['rgba(255, 206, 86, 0.2)', 'rgba(255, 206, 86, 1)'],
    'BUSY': ['rgba(75, 192, 192, 0.2)', 'rgba(75, 192, 192, 1)'],
    'FAILED': ['rgba(153, 102, 255, 0.2)', 'rgba(153, 102, 255, 1)'],
};
function Graphics(props) {
    const [pie, setPie] = useState({})
    const [pie2, setPie2] = useState({})
    const [loader, setLoader] = useState(false)
    const [status, setStatus] = useState({})
    const dispatch = useDispatch()
    const [disposition, setDisposition] = useState({})
    const [newObj, setObj] = useState({})
    const [newObjD, setObjD] = useState({})
    const [duration, setDuration] = useState({})
    const [rate, setRate] = useState({})
    const [durationAll, setDurationAll] = useState({})
    const historyData = useSelector(state => state.history.historyData)
    const location = useLocation()
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    useEffect(() => {
        (async () => {
            try {
                setLoader(true)
                await dispatch(historyRequest(10,1,{
                    endTime: query.endTime,
                    startTime: query.startTime,
                    number: query.number || '',
                    did: query.did || '',
                    caller: query.caller || '',
                    status: query.status || '',
                    disposition: query.disposition || '',
                    line: query.line || '',
                    direction: query.direction || '',
                    period: query.period || ''
                }))
                let isTrue = moment(query.endTime ? query.endTime + timeZoneEnd : timeEndEnd).diff(moment(query.startTime ? query.startTime + timeZoneStart : timeStartStart), "months") < 1;
                const { data } = await Api.graphic('status', isTrue, {
                    timeStartStart: query.startTime ? query.startTime + timeZoneStart : timeStartStart,
                    timeEndEnd: query.endTime ? query.endTime + timeZoneEnd : timeEndEnd,
                    caller: query.caller || '',
                    did: query.did || '',
                    number: query.number || ''
                })
                let allData = data.facet_counts.facet_pivot.status;
                let callName;
                let arr = {};
                let obj = {};
                let range;
                if(!allData.length){
                    setStatus({})
                    setObj({})
                
                }
                for (let i = 0; i < allData.length; i++) {
                    range = data.facet_counts.facet_pivot.status[i].ranges.start.counts;
                    callName = data.facet_counts.facet_pivot.status[i].value
                    let year;
                    let count;
                    let yearSplit = [...range];
                    let countSplit = [...range];
                    let date;
                    let dateArr;
                    obj = {};
                    for (let j = 0; j < range.length / 2; j++) {
                        year = yearSplit.splice(0, 2)[0]
                        count = countSplit.splice(0, 2)[1]
                        if (isTrue) {
                            date = String(new Date(year));
                            dateArr = date.split(' ');
                            let dateYear = dateArr[2];
                            let dateMonth = dateArr[1];
                            dateArr = dateMonth + ' ' + dateYear;
                            year = dateArr;
                            obj[year] = count;
                        } else {
                            if (
                                ((moment(year).isAfter(query.startTime ? query.startTime + timeZoneStart : timeStartStart) || new Date(year).getMonth() === new Date(query.startTime ? query.startTime + timeZoneStart : timeStartStart).getMonth()) && moment(year).isBefore(query.endTime ? query.endTime + timeZoneEnd : timeEndEnd))
                                || moment(year).isSame(query.startTime ? query.startTime + timeZoneStart : timeStartStart) || moment(year).isSame(query.endTime ? query.endTime + timeZoneEnd : timeEndEnd)
                            ) {
                                date = String(new Date(year));
                                dateArr = date.split(' ');
                                dateArr.slice(1, 4);
                                let dateYear = dateArr[3];
                                let dateMonth = dateArr[1];
                                dateArr = dateMonth + ' ' + dateYear;
                                year = dateArr;
                                obj[year] = count;
                            }
                        }

                    }
                    arr[callName] = obj

                    setStatus(arr)
                    setObj(obj)
                }
                const disposition = await Api.graphic('disposition', isTrue, {
                    timeStartStart: query.startTime ? query.startTime + timeZoneStart : timeStartStart,
                    timeEndEnd: query.endTime ? query.endTime + timeZoneEnd : timeEndEnd,
                    caller: query.caller || '',
                    did: query.did || '',
                    number: query.number || ''
                })
                allData = disposition.data.facet_counts.facet_pivot.disposition;
                arr = {};
                obj = {};
                if(!allData.length){
                    setDisposition({})
                    setObjD({})
                }
                for (let i = 0; i < allData.length; i++) {
                    range = disposition.data.facet_counts.facet_pivot.disposition[i].ranges.start.counts;
                    callName = disposition.data.facet_counts.facet_pivot.disposition[i].value
                    let timeRange;
                    let count;
                    let timeRangeSplit = [...range];
                    let countSplit = [...range];
                    let date;
                    let dateArr;
                    obj = {};
                    for (let j = 0; j < range.length / 2; j++) {
                        timeRange = timeRangeSplit.splice(0, 2)[0]
                        count = countSplit.splice(0, 2)[1]
                        if (isTrue) {
                            date = String(new Date(timeRange));
                            dateArr = date.split(' ');
                            let dateYear = dateArr[2];
                            let dateMonth = dateArr[1];
                            dateArr = dateMonth + ' ' + dateYear;
                            timeRange = dateArr;
                            obj[timeRange] = count;
                        } else {
                            if (
                                ((moment(timeRange).isAfter(query.startTime ? query.startTime + timeZoneStart : timeStartStart) || new Date(timeRange).getMonth() === new Date(query.startTime ? query.startTime + timeZoneStart : timeStartStart).getMonth()) && moment(timeRange).isBefore(query.endTime ? query.endTime + timeZoneEnd : timeEndEnd))
                                || moment(timeRange).isSame(query.startTime ? query.startTime + timeZoneStart : timeStartStart) || moment(timeRange).isSame(query.endTime ? query.endTime + timeZoneEnd : timeEndEnd)
                            ) {
                                date = String(new Date(timeRange));
                                dateArr = date.split(' ');
                                dateArr.slice(1, 4);
                                let dateYear = dateArr[3];
                                let dateMonth = dateArr[1];
                                dateArr = dateMonth + ' ' + dateYear;
                                timeRange = dateArr;
                                obj[timeRange] = count;
                            }
                        }

                    }
                    arr[callName] = obj
                    setDisposition(arr)
                    setObjD(obj)
                }
                setLoader(false)
            } catch (e) {
                console.log(e)
            }
        })()
    }, [location.search, timeEndEnd, timeStartStart])

    useEffect(() => {
        const allData = historyData?.facet_counts?.facet_fields?.status;
        const allDataDisp = historyData?.facet_counts?.facet_fields?.disposition;
        let callSatus;
        let callSatusCount;
        let pieObj = {};
        let pieObj2 = {}
        for (let i = 0; i < allData?.length; i++) {
            const dataStatus = [...allData];
            const dataCount = [...allData];
            for (let j = 0; j < allData?.length / 2; j++) {
                callSatus = dataStatus.splice(0, 2)[0]
                callSatusCount = dataCount.splice(0, 2)[1]
                if (callSatus !== null && callSatus !== "Incaming Call") {
                    pieObj[callSatus] = [callSatusCount]
                }
            }

        }
        setPie(pieObj)

        for (let i = 0; i < allDataDisp?.length; i++) {
            const dataStatus = [...allDataDisp];
            const dataCount = [...allDataDisp];
            for (let j = 0; j < allDataDisp?.length / 2; j++) {
                callSatus = dataStatus.splice(0, 2)[0]
                callSatusCount = dataCount.splice(0, 2)[1]
                if (callSatus !== null) {
                    pieObj2[callSatus] = [callSatusCount]
                }
            }

        }
        setPie2(pieObj2)
    }, [historyData,location.search,])

    useEffect(() => {
        (async () => {
            try {
                let yourDate = new Date()
                const offset = yourDate.getTimezoneOffset()
                yourDate = new Date(yourDate.getTime() - (offset * 60 * 1000))
                const { data } = await Api.duration({
                    endTime: query.endTime || yourDate.toISOString().split('T')[0],
                    startTime: query.startTime || yourDate.toISOString().split('T')[0],
                    number: query.number || '',
                    status: query.status || '',
                    disposition: query.disposition || '',
                    line: query.line || '',
                    caller:query.caller || '',
                    did:query.did || '',
                    direction: query.direction || '',
                    period: query.period || ''
                })
                const allData = data.duration.stats.stats_fields.duration;
                const allDataRate = data.rate.stats.stats_fields.rate;
                let filterData = {}
                let filterDataRate = {}
                let minTime = Utils.convertHMS(allData.min)
                if (Utils.convertHMS(allData.min) === "NaN:NaN:NaN") {
                    minTime = "00:00:00"
                }

                let maxTime = Utils.convertHMS(allData.max)
                if (Utils.convertHMS(allData.max) === "NaN:NaN:NaN") {
                    maxTime = "00:00:00"
                }
                let meanTime = Utils.convertHMS(allData.mean)
                if (Utils.convertHMS(allData.mean) === "NaN:NaN:NaN") {
                    meanTime = "00:00:00"
                }
                filterData["Minimum"] = allData.min;
                filterData["Maximum"] = allData.max;
                filterData["Count"] = allData.count;


                setDuration(filterData)
                setDurationAll({
                    meanTime,
                    maxTime,
                    minTime,
                    count: allData.count
                })
                filterDataRate["Minimum"] = allDataRate.min || 0;
                filterDataRate["Maximum"] = allDataRate.max || 0;
                filterDataRate["Count"] = allDataRate.count || 0;
                setRate(filterDataRate)
            } catch (e) {
                console.log(e)
            }
        })()
    }, [location.search,])

    const keyOrder = ['Incoming Call', 'Local Call', 'Out Call', 'Redirect Call'];

    const chartData = keyOrder.map(key => pie[key] || 0);

    const backgroundColor = keyOrder.map(key => keys[key + ' b']);
    const borderColor = keyOrder.map(key => keys[key]);
    const pieKeyOrder = ['NO ANSWER', 'ANSWERED', 'ANSWER LATER', 'BUSY', 'FAILED'];

    const filteredPieKeys = pieKeyOrder.filter(k => pie2.hasOwnProperty(k));
    const pieData = filteredPieKeys.map(k => pie2[k]);

    const labels = Object.keys(newObjD);
    const labelCount = labels.length;

    const datasets = pieKeyOrder.map(key => ({
        label: graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key,
        data: disposition[key]
            ? Object.values(disposition[key])
            : Array(labelCount).fill(0),
        borderColor: colors[key][0],
        backgroundColor: colors[key][1],
        // fill: false,
    }));
    const labelsDisposition = Object.keys(newObj);
    const labelCountDisposition = labelsDisposition.length;

    const datasetsDisposition = keyOrder.map(key => ({
        label: graphics[key][+localStorage.getItem('atsLang') || 1],
        data: status[key] ? Object.values(status[key]) : Array(labelCountDisposition).fill(0),
        borderColor: keys[key + ' b'],
        backgroundColor: keys[key],
        // fill: false,
      }))

    if (loader) {
        return (<div className="row w-100">
            <h3 style={{ textAlign: 'center', margin: '31px 0' }}>{graphics.loading[+localStorage.getItem('atsLang') || 1]}</h3>
        </div>)
    } else {
        return (
            <div className="row w-100">
                <h3 style={{ textAlign: 'center', margin: '31px 0' }}>{graphics.calls_type[+localStorage.getItem('atsLang') || 1]}</h3>
                <div className="col-md-8">
                    <div className="d-flex align-items-center justify-content-center">
                        <Line
                            datasetIdKey="id"
                            data={{
                                labels: labelsDisposition,
                                datasets: datasetsDisposition,
                            }}
                            type="line"
                        />
                    </div>
                </div>
                <div className="col-md-4 my_canvas">
                    <Pie
                        type="pie"
                        data={{
                            labels: keyOrder.map(key => graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key),
                            datasets: [{
                                data: chartData,
                                fill: false,
                                backgroundColor: backgroundColor,
                                borderColor: borderColor,
                                borderWidth: 1,
                            },
                            ],
                        }}
                    />
                </div>
                <h3 style={{ textAlign: 'center', margin: '31px 0' }}>{graphics.calls_status[+localStorage.getItem('atsLang') || 1]}</h3>
                <div className="col-md-8">
                    <Line
                        datasetIdKey="id"
                        data={{
                            labels: labels.map(key => graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key),
                            datasets,
                        }}
                        type="line"
                    />
                </div>
                <div className="col-md-4">
                    <Pie
                        type="pie"
                        data={{
                            labels: filteredPieKeys.map(key => graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key),
                            datasets: [{
                                data: pieData,
                                fill: false,
                                backgroundColor: Object.values(pieBackgroundColor),
                                borderColor: Object.values(pieBorderColor),
                                borderWidth: 1,
                            },
                            ],
                        }}
                    />
                </div>
                <h3 style={{ textAlign: 'center', margin: '31px 0' }}>{graphics.calls_duration[+localStorage.getItem('atsLang') || 1]}</h3>
                <div className="col-md-6">
                    <Bar
                        type="bar"
                        data={{
                            labels: Object.keys(duration).map(key => graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key),
                            datasets: [{
                                data: Object.values(duration),
                                backgroundColor: [
                                    'rgb(255, 99, 132)',
                                    'rgb(54, 162, 235)',
                                    'rgb(255, 205, 86)',
                                ]
                            },
                            ]
                        }}

                        options={{
                            plugins: {
                                legend: {
                                    display: false
                                }
                            },
                            scales: {
                                y: {
                                    beginAtZero: true
                                }
                            }
                        }}
                    />
                </div>
                <div className="col-md-6">
                    <div className="d-flex align-items-center flex-column justify-content-center" style={{ height: 200 }}>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.minimum[+localStorage.getItem('atsLang') || 1]}</span> - {durationAll?.minTime} </p>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.maximum[+localStorage.getItem('atsLang') || 1]}</span> - {durationAll?.maxTime}</p>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.count[+localStorage.getItem('atsLang') || 1]}</span> - {durationAll?.count}</p>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.average_duration[+localStorage.getItem('atsLang') || 1]}</span> - {durationAll?.meanTime}</p>
                    </div>
                </div>
                <h3 style={{ textAlign: 'center', margin: '31px 0' }}>{graphics.calls_rating[+localStorage.getItem('atsLang') || 1]}</h3>
                <div className="col-md-6">
                    <Bar
                        type="bar"
                        data={{ 
                            labels: Object.keys(rate).map(key => graphics[key]?.[+localStorage.getItem('atsLang') || 1] || graphics[key.toLowerCase()]?.[+localStorage.getItem('atsLang') || 1] || key),
                            datasets: [{
                                data: Object.values(rate),
                                backgroundColor: [
                                    'rgb(255, 99, 132)',
                                    'rgb(54, 162, 235)',
                                    'rgb(255, 205, 86)',
                                ]
                            },
                            ]
                        }}

                        options={{
                            plugins: {
                                legend: {
                                    display: false
                                }
                            },
                            scales: {
                                y: {
                                    beginAtZero: true
                                }
                            }
                        }}
                    />
                </div>
                <div className="col-md-6">
                    <div className="d-flex align-items-center flex-column justify-content-center" style={{ height: 200 }}>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.minimum[+localStorage.getItem('atsLang') || 1]}</span> - {rate?.Minimum} </p>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.maximum[+localStorage.getItem('atsLang') || 1]}</span> - {rate?.Maximum}</p>
                        <p><span style={{ borderBottom: '1px solid', paddingBottom: 5 }}>{graphics.count[+localStorage.getItem('atsLang') || 1]}</span> - {rate?.Count}</p>
                    </div>
                </div>

            </div>
        )
            ;
    }

}

export default Graphics;
